// Products.js
import React, { useState, useEffect } from "react";
import { Footer } from "../components/Footer.js";
import { Slide_title } from "../components/slide-title.js";
import { Spe_offer } from "../components/spe_offer.js";
import LazyLoad from "react-lazy-load";
import filledHeartImage from "./../assets/img/heart.svg";
import unfilledHeartImage from "./../assets/img/heartunfilled.svg";
import { ProductGridSkeleton } from "../components/Skeleton.js";
import { ProductGridImage, productImageUrl } from "../components/ProductGridImage.js";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
    product_list_category_wise,
    wishlist_api,
    wishlist_remove_api,
    get_wishlist,
    category_details,
    new_arrivals
} from "../service/api.js";
import Head_CateHead from "../components/Head_CateHead.js";
import { Pagination } from "@mui/material";
import Breadcrumb from '../components/Breadcrumb.js';  // Ensure correct import path


export const CategoryListing = () => {
    const navigate = useNavigate();
    const { slug } = useParams();
    const [page, setPage] = useState(1);
    const [totalPages, settotalPages] = useState(0);
    const [crumbs, setcrumbs] = useState([]);

    useEffect(() => {
        var vrcrumbs = [{ label: "Home", path: "/" }];
        vrcrumbs.push({ label: title, path: "" })
        setcrumbs(vrcrumbs)
        setProductArray([]);
        setPage(1);
        setListLoading(true);
        // fetchData();
        fetchAllCate();
    }, [slug])
    var id = '';
    const [productArray, setProductArray] = useState([]);
    const [isAuthenticated, setIsAuthenticated] = useState(
        !!localStorage.getItem("token")
    );
    const [wishlistProductId, setWishlistProductId] = useState([])
    const [shouldReload, setShouldReload] = useState(false);

    const getUserWishlist = async () => {
        try {
            const res = await get_wishlist();
            const wishListId = res.data?.Data?.map((item) => {
                return item.ProductID
            })
            setWishlistProductId([...wishListId])
        } catch (error) {
            console.error(error)
        }
    }
    const [title, setTitle] = useState("")
    const [description, setdescription] = useState("")
    const [bannerimage, setbannerimage] = useState("")
    // useEffect(() => {
    //     if (productArray == []) {
    //         setPage(1);
    //     }
    //  }, [productArray])

    const showCategoryProducts = (rows, pages) => {
        setProductArray(Array.isArray(rows) ? rows : []);
        if (pages != null) settotalPages(pages);
        setListLoading(false);
    };

    // Title comes from the category call. The grid comes from the product call.
    // Neither one waits for the wishlist.
    const fetchAllCate = async () => {
        getUserWishlist();
        loadCategoryProducts(slug, 1);
        try {
            const res = await category_details(slug);
            if (res?.response?.status == 400) {
                navigate("/404");
                return;
            }
            const category = res?.data?.Data?.[0];
            if (category?.CategoryName) {
                setTitle(category.CategoryName);
                setdescription(category.Description);
                setbannerimage(category.CategoryBanner);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const loadCategoryProducts = async (categorySlug, pageNo) => {
        try {
            if (categorySlug === "new") {
                const response = await new_arrivals();
                setTitle("New");
                setbannerimage("");
                if (response?.status === 200) {
                    showCategoryProducts(response.data.data || response.data.Data, response.data.totalPages);
                    return;
                }
            } else {
                const response = await product_list_category_wise(categorySlug, pageNo, 24);
                if (response?.status === 200) {
                    showCategoryProducts(response.data.Data, response.data.totalPages);
                    return;
                }
            }
            setListLoading(false);
        } catch (error) {
            console.error("Error fetching product data:", error);
            setListLoading(false);
        }
    };


    const [listLoading, setListLoading] = useState(true);

    const toggleWishlist = async (ProductID, UserProductWishlist) => {
        try {
            let response;
            const checkWish = wishlistProductId.find((userWish) => userWish === ProductID)

            if (!checkWish) {
                response = await wishlist_api(ProductID); // Add to wishlist

                if (response.status === 200) {
                    const updatedProductArray = productArray.map((product) =>
                        product.ProductID === ProductID
                            ? {
                                ...product,
                                UserProductWishlist: [response.data.UserProductWishlist], // Add to wishlist
                            }
                            : product
                    );

                    setProductArray(updatedProductArray);
                }
            } else {
                response = await wishlist_remove_api(ProductID); // Remove from wishlist

                if (response.status === 200) {
                    const updatedProductArray = productArray.map((product) =>
                        product.ProductID === ProductID
                            ? {
                                ...product,
                                UserProductWishlist: [], // Remove from wishlist
                            }
                            : product
                    );

                    setProductArray(updatedProductArray);
                }
            }
            getUserWishlist()
        } catch (error) {
            console.error("Error toggling wishlist:", error);
        }
    };

    const handlePageChange = async (event, page) => {
        setListLoading(true);
        setPage(page);
        window.scrollTo(0, 0);
        await loadCategoryProducts(slug, page);
    };



    return (
        <div>
            <Head_CateHead />
            <div className="collection_wrapper">
                {bannerimage == null || bannerimage == '' ?
                    <div style={{ position: 'relative', height: '250px', background: '#F2F9FB', marginBottom: '40px' }}>
                        <h1 style={{ textAlign: 'center', paddingTop: '80px', color: '#01AEF0', fontSize: '3.5vw' }}>{title}</h1>
                        <span style={{ color: '#DFF3FA', position: 'absolute', width: "300px", left: '80%', top: '-30%', fontSize: '10.5vw', fontFamily: 'poppins', fontWeight: '600', height: "300px", overflow: "hidden" }}>{title}</span>
                        <span style={{ color: '#DFF3FA', position: 'absolute', right: '83%', bottom: '-14%', fontSize: '10.5vw', fontFamily: 'poppins', fontWeight: '600', height: "260px", overflow: "hidden" }}>{title}</span>
                    </div>
                    :
                    <img style={{ width: '100%', marginBottom: '40px' }} src={process.env.REACT_APP_API_URL + bannerimage} alt={title || "Category"} />
                }
                <div>

                </div>
                <div className="container" style={{ height: 'auto', overflow: 'auto' }}>
                    <Breadcrumb crumbs={crumbs} />
                    {listLoading ? (
                        <ProductGridSkeleton />
                    ) : (
                        <div className="products_list">
                            {productArray.map((product, index) => (
                                <LazyLoad key={index} offsetVertical={200}>
                                    <Link to={`/product/${product.Slug}`} key={index}>
                                        <div className="arrivals_box" key={index}>
                                            <div className="arrivals_img">
                                                <div className="product_head">
                                                    {isAuthenticated && (
                                                        <button
                                                            className="product_save"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                toggleWishlist(
                                                                    product.ProductID,
                                                                    product.UserProductWishlist
                                                                );
                                                            }}
                                                        >

                                                            <img
                                                                src={wishlistProductId.find((wishPro) => wishPro === product.ProductID)
                                                                    ? filledHeartImage // Show unfilled heart for products not in the wishlist
                                                                    : unfilledHeartImage // Show filled heart for products in the wishlist
                                                                }
                                                                alt="Heart Icon"
                                                            />
                                                        </button>
                                                    )}
                                                </div>
                                                <ProductGridImage
                                                    src={productImageUrl(product.ProductImage)}
                                                    alt={product.ProductName || "Product"}
                                                />
                                            </div>
                                            <div className="arrivals_content">
                                                <div className="arrivals_content_title">
                                                    <h3>{product.ProductName}</h3>
                                                    <p className="sku" style={{ marginLeft: '1', fontSize: '0.83vw', color: '#252525' }}>SKU: {product.SKU}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </LazyLoad>
                            ))}
                        </div>
                    )}
                    {totalPages > 1 && (
                        <div className="trend_pagination" style={{ display: 'block', position: 'relative', paddingBottom: '100px', paddingTop: '50px' }}>
                            <Pagination count={totalPages} shape="rounded" onChange={handlePageChange} />
                        </div>
                    )}
                </div>
            </div>
            {/* <Spe_offer /> */}
            <Footer />
        </div>
    );
};
